// Text of Settings -> Configuration -> Sessions (SessionsConfiguration.tsx).
import type { SessionPolicyView } from '../../../services/configuration';

export function hoursText(h: number): string {
  return `${h} hour${h === 1 ? '' : 's'}`;
}

/** The confirmation text of a change (what happens to people who are signed in now). */
export function changeSummary(view: SessionPolicyView, adminMinutes: number, dispatcherHours: number): string {
  const parts: string[] = [];
  if (adminMinutes !== view.admin_session_minutes) {
    parts.push(`Management Client: ${view.admin_session_minutes} -> ${adminMinutes} minutes` +
      (adminMinutes < view.admin_session_minutes ? ' (sign-ins older than that end now)' : ' (current sign-ins are extended)'));
  }
  if (dispatcherHours !== view.dispatcher_session_hours) {
    parts.push(`Dispatcher: ${hoursText(view.dispatcher_session_hours)} -> ${hoursText(dispatcherHours)}` +
      (dispatcherHours < view.dispatcher_session_hours ? ' (sign-ins older than that end now)' : ' (current sign-ins are extended)'));
  }
  return parts.join('\n');
}
